<template>
  <div class="addApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading" :style="'min-height:'+curHeight+'px'">
    <div class="comment">
      <h2>Journal Hub</h2>
      <div class="txtEdit">
        <textarea placeholder="Please Enter Content" v-model="content"></textarea>
        <div style="clear:both"></div>
      </div>
    </div>
    <div class="btn" @click="save">Submit</div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        content:'',
        username:'游客'
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      save:function(){
        var that = this;
        if(that.content == ''){
          that.$alert('请输入内容', '提示');
          return false;
        }
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/index/saveLyan',
          data:{
            content:that.content,
            username:that.username
          },
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.$router.go(-1);
            }else{
              that.$alert(data.message, '提示');
            }
            that.fullscreenLoading = false;
          }
        })
      }
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .addApp .el-message-box{
    width:30%
  }
  .addApp{
    max-width:750px;
    margin:0 auto;
  }

  .addApp .comment{
    background: #F1F2F5;
    width:96%;
    margin:0 auto
  }

  .addApp .comment h2{
    width:94%;
    margin:0 auto;
    position:relative;
    font-size:16px;
    padding:15px 0 15px 2%;
  }
  .addApp .comment h2:after{
    content:'';
    width: 4px;
    height: 14px;
    background: #000;
    position:absolute;
    left:0px;
    top:19px;
    border-radius: 3px;
  }
  .addApp .comment .txtEdit{
    width:96%;
    background:#fff;
    margin:0 auto;
    padding:15px 0
  }
  .addApp .comment .txtEdit textarea{
    width: calc(94% - 16px);
    margin:0 auto;
    display:block;
    border: 1px solid #E3E6EB;
    height:86px;
    resize:none;
    border-radius: 3px;
    outline:none;
    font-size:15px;
    color:#000;
    padding:8px
  }
  .addApp  .btn{
    background: #0052D9;
    width: 80%;
    height: 42px;
    border-radius: 3px;
    color:#fff;
    text-align:center;
    line-height: 42px;
    margin-top:8px;
    margin:52px auto 0 auto;
    font-size:15px
  }
  
</style>